var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-box"},[_c('div',{staticClass:"common-seach-wrap"},[_c('el-form',{staticClass:"demo-form-inline",attrs:{"size":"small","inline":true}},[_c('el-form-item',[_c('el-button',{attrs:{"size":"small","icon":"el-icon-notebook-2"},on:{"click":_vm.chooseList}},[_vm._v("选择素材中心列表")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95106bae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/setlink/part/Material.vue
// module id = null
// module chunks = 